import React from 'react';
import { FaChevronDown, FaDownload, FaPlus } from 'react-icons/fa';
import { CLIENT_CATALOG, ROUTES } from '../../constant';

export default function ClientCatalogClientBar({
  clients,
  selectedClient,
  selectedClientId,
  setSelectedClientId,
  showClientDropdown,
  setShowClientDropdown,
  productCount,
  onOpenImport,
}) {
  return (
    <div className="client-selector-bar justify-content-between align-items-center d-flex">
      <div className="d-flex gap-3 align-items-center">
        <div className="client-dropdown-wrapper">
          <button
            type="button"
            className="client-dropdown-btn"
            onClick={() => setShowClientDropdown(!showClientDropdown)}
          >
            <span>
              {selectedClient?.name ||
                selectedClient?.clientId ||
                CLIENT_CATALOG.SELECT_CLIENT_PLACEHOLDER}
            </span>
            <FaChevronDown className={`dropdown-icon ${showClientDropdown ? 'open' : ''}`} />
          </button>
          {showClientDropdown && (
            <div className="client-dropdown-list">
              {clients.length === 0 ? (
                <div className="dropdown-empty">
                  <p className="text-muted small mb-2">{CLIENT_CATALOG.NO_CLIENTS_YET}</p>
                  <a href={ROUTES.CRM_ADD_CLIENT} className="btn btn-sm btn-outline-primary">
                    <FaPlus className="me-1" /> {CLIENT_CATALOG.BTN_ADD_CLIENT}
                  </a>
                </div>
              ) : (
                clients.map((client) => (
                  <div
                    key={client.id ?? client._id}
                    role="button"
                    tabIndex={0}
                    className={`dropdown-item ${String(selectedClientId) === String(client.id) ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedClientId(String(client.id));
                      setShowClientDropdown(false);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        setSelectedClientId(String(client.id));
                        setShowClientDropdown(false);
                      }
                    }}
                  >
                    <div className="dropdown-item-name">{client.name || client.clientId}</div>
                    <div className="dropdown-item-code">{client.clientId}</div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
        <p className="text-muted small mb-0">{CLIENT_CATALOG.PRODUCTS_IN_CATALOG(productCount)}</p>
      </div>
      <button type="button" className="btn btn-primary" onClick={onOpenImport}>
        <FaDownload className="me-2" /> {CLIENT_CATALOG.BTN_IMPORT_PRODUCTS}
      </button>
    </div>
  );
}
